import { Link } from "react-router-dom";
import { useT, useLp, useLang } from "../lib/i18n";
import { currentSourcePage, trackDownloadClick } from "../lib/plausible";

export function FooterCta() {
  const t = useT();
  const lp = useLp();
  const lang = useLang();

  return (
    <section className="border-t border-margin dark:border-paper/10">
      <div className="mx-auto max-w-4xl px-6 py-24 text-center">
        <h2 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight text-ink dark:text-paper">
          {t.footerCta.heading}
        </h2>
        <p className="mt-6 text-lg text-ink/70 dark:text-paper/70">
          {t.footerCta.body}
        </p>
        <div className="mt-10">
          <Link
            to={lp + "/downloads"}
            onClick={() => trackDownloadClick({ source_page: currentSourcePage(), lang, os: "unknown" })}
            className="inline-flex items-center gap-2 rounded-full bg-ink px-7 py-3.5 text-sm font-medium text-paper hover:bg-ink/90 transition-colors dark:bg-paper dark:text-ink dark:hover:bg-paper/90"
          >
            {t.footerCta.cta}
            <span className="text-xs opacity-70">{t.footerCta.ctaSub}</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
